import React from 'react'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle, ResumeButton } from './HeroStyle'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import HeroImg from '../../images/nHeroImg.png'
import HeroBgAnimation from '../HeroBgAnimation'
import { useLanguage } from '../../utils/LanguageContext';
import styled from 'styled-components';

const ResumeGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    justify-content: center;
  }
`;

const Hero = () => {
  const { t, language } = useLanguage();

  return (
    <div id="about" role="main" aria-label="About section">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer id="main-content">
          <HeroLeftContainer>
            <Title>{t.heroGreeting} <br /> {Bio.name}</Title>
            <TextLoop>
              {t.iAmA} <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles[language],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>
              {Bio.description[language]}
            </SubTitle>
            <ResumeGroup>
              <ResumeButton href={Bio.resume_en} target='_blank' rel='noopener noreferrer' aria-label="View English Resume">
                {t.checkResume}
              </ResumeButton>
              <ResumeButton href={Bio.resume_fr} target='_blank' rel='noopener noreferrer' aria-label="View French Resume">
                {t.checkResumeFr}
              </ResumeButton>
            </ResumeGroup>
          </HeroLeftContainer>
          <HeroRightContainer>
            <Img src={HeroImg} alt="Messi II Innocent Rostand - Fullstack Developer" loading="lazy" />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  )
}

export default Hero
